export default "__VITE_ASSET__COKLuSaJ__"